import {
  Dialog,
  DialogType,
  Icon,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";
import { VehicleHistoryTable } from "components/VehicleHistoryTable";
import { useGetVehicleHistoryInformation } from "hooks/data/queries/useGetVehicleHistoryInformation";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setVehicleHistoryDialog } from "store/fleetPage";
import { useSelector } from "store/hooks";
import { useTheme } from "styled-components";
import { IStyledTheme } from "theme/types";

export const VehicleHistoryDialog = () => {
  const { t } = useTranslation();
  const theme = useTheme() as IStyledTheme;
  const dispatch = useDispatch();

  const vehicleHistoryDialog = useSelector(
    (s) => s.fleetPage.vehicleHistoryDialog
  );

  const close = () => {
    dispatch(
      setVehicleHistoryDialog({
        isOpen: false,
        fleetId: null,
        vehicleId: null,
      })
    );
  };

  const fleetAppSettings = useSelector((s) => s.fleetForm.fleetAppSettings);

  const { vehicleId, fleetId } = vehicleHistoryDialog;

  const { data: vehicleHistoryData, isLoading: isVehicleHistoryLoading } =
    useGetVehicleHistoryInformation({
      fleetId,
      vehicleId,
      enabled: !!fleetId && !!vehicleId,
    });

  const title = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Icon
        iconName="History"
        style={{
          color: theme.palette.themePrimary,
          fontSize: "25px",
          marginRight: "5px",
        }}
      />
      {t("bfm.vehicle.tabs.history")}
    </div>
  );

  return (
    <Dialog
      hidden={!vehicleHistoryDialog.isOpen}
      onDismiss={close}
      dialogContentProps={{
        type: DialogType.normal,
        title,
        showCloseButton: true,
      }}
      minWidth={1000}
      maxWidth={1200}
      modalProps={{
        isBlocking: true,
      }}
    >
      <div style={{ minHeight: "400px", maxHeight: "600px", overflow: "auto" }}>
        {isVehicleHistoryLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Spinner size={SpinnerSize.large} label={t("greco.loading")} />
          </div>
        ) : (
          <VehicleHistoryTable
            data={vehicleHistoryData || []}
            showUrgent={!!fleetAppSettings?.SHOW_URGENT_ON_STATUS_CHANGE}
          />
        )}
      </div>
    </Dialog>
  );
};
